import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { composeEvent } from '@icp/utils';
import { HELPER_TEXT_TYPES, helpersIsEmpty } from '@icp/form-renderer-core';
import { FormHelperTextMaterial } from '../../FormHelperText';

function isTypedNumber(newValue) {
  const newValueNumber = Number(newValue);
  return !Number.isNaN(newValueNumber) && String(newValueNumber).length === newValue.length;
}

const NumberPickerMaterial = forwardRef(function NumberPickerMaterial(props, ref) {
  const {
    id,
    title,
    value,
    disabled,
    readonly,
    componentProps,
    validation,
    status,
    helpers,
    onChange,
    onTouchChanged,
    onBlur,
    // min, max, step, precision, formatOptions
  } = props;

  const [tempValue, setTempValue] = useState(value);
  const { changeDelayToBlur, ...otherComponentProps } = componentProps;

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setTempValue(newValue);

    if (isTypedNumber(newValue) && !changeDelayToBlur) {
      onChange(Number(newValue));
    }
  };

  const handleBlur = (event) => {
    const newValue = event.target.value;
    setTempValue(newValue);
    if (isTypedNumber(newValue) && changeDelayToBlur) {
      onChange(Number(newValue));
    }
    if (onTouchChanged) {
      onTouchChanged();
    }
  };

  return (
    <TextField
      {...otherComponentProps}
      fullWidth={true}
      id={id}
      label={title}
      value={tempValue ?? ''}
      inputMode="numeric"
      error={status === 'error'}
      helperText={!helpersIsEmpty(helpers) ? <FormHelperTextMaterial helpers={helpers} /> : null}
      required={validation?.required}
      disabled={disabled}
      InputProps={{
        readOnly: readonly,
      }}
      type="number"
      onChange={handleChange}
      onBlur={composeEvent(handleBlur, onBlur)}
      ref={ref}
    />
  );
});

NumberPickerMaterial.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  componentProps: PropTypes.shape({
    className: PropTypes.string,
    changeDelayToBlur: PropTypes.bool,
  }),
  fieldTitleProps: PropTypes.shape({
    showColon: PropTypes.bool,
  }),
  validation: PropTypes.shape({
    required: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,

  status: PropTypes.oneOf(HELPER_TEXT_TYPES),
  helpers: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(HELPER_TEXT_TYPES),
      text: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchChanged: PropTypes.func,
};

export default NumberPickerMaterial;
